import React from 'react';
import styles from './styles.css';
import BYOPTaxableCard from './BYOPTaxableCard';
import SelectFundsCard from './SelectFundsCard';
import MoneyMarketCard from './MoneyMarketCard';

const TaxableContents = () => {
  return (
    <>
      <div className="grid-container single-row">
        <div data-e2e="byop-taxable-card" className="grid-item">
          <BYOPTaxableCard />
        </div>
        <div data-e2e="select-funds-card" className="grid-item">
          <SelectFundsCard />
        </div>
        <div data-e2e="money-market-card" className="grid-item">
          <MoneyMarketCard />
        </div>
      </div>
      <div className="select-funds-disclaimer">
        *T. Rowe Price® Select Funds are curated mutual funds based on Overall
        Morningstar rating, Morningstar Analyst rating, expense ratios, net new
        flows and qualitative factors.
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default TaxableContents;
